import React from 'react';
import { useNavigate } from 'react-router-dom';
import LogoPollbolt from '../logo-pollbolt-main.svg';

const Footer = () => {
  const navigate = useNavigate();

  const links = {
    product: [

      { name: 'Plans', href: '/plans' },
      { name: 'Templates', href: '/templates' }
    ],
    resources: [
      { name: 'Blog', href: '/blog' }
    ],
    company: [
      { name: 'About Us', href: '/about' },
      { name: 'Contact', href: '/contact' },
      { name: 'Legal', href: '/legal' }
    ],
    legal: [
      { name: 'Privacy Policy', href: '/privacy-policy' },
      { name: 'Terms of Service', href: '/terms-of-service' },
      { name: 'Cookie Policy', href: '/cookie-policy' },
      { name: 'Data Processing Agreement', href: '/data-processing-agreement' },
      { name: 'Responsible Disclosure Policy', href: '/responsible-disclosure' }
    ],
    social: [
      { name: 'Twitter', href: 'https://twitter.com' },
      { name: 'LinkedIn', href: 'https://linkedin.com' },
      { name: 'GitHub', href: 'https://github.com' }
    ]
  };

  return (
    <footer className="bg-white text-black">
      <div className="max-w-[1920px] mx-auto px-4">
        <div className="max-w-[1600px] mx-auto pb-20">
          {/* Main Footer Content */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-6 gap-12 mb-16">
            {/* Logo and Description */}
            <div className="lg:col-span-2">
              <img 
                src={LogoPollbolt} 
                alt="PollBolt Logo" 
                className="h-8 mb-6" 
              />
              <p className="text-gray-600 max-w-sm">
                Create and share surveys in minutes. Get instant responses and powerful analytics.
              </p>
            </div>

            {/* Links Sections */}
            <div>
              <h3 className="font-['Inter'] font-medium text-lg mb-4">Product</h3>
              <ul className="space-y-3">
                {links.product.map((link) => (
                  <li key={link.name}>
                    <a 
                      href={link.href} 
                      className="text-gray-600 hover:text-black transition-colors"
                    >
                      {link.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h3 className="font-['Inter'] font-medium text-lg mb-4">Resources</h3>
              <ul className="space-y-3">
                {links.resources.map((link) => (
                  <li key={link.name}>
                    <a 
                      href={link.href} 
                      className="text-gray-600 hover:text-black transition-colors"
                    >
                      {link.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h3 className="font-['Inter'] font-medium text-lg mb-4">Company</h3>
              <ul className="space-y-3">
                {links.company.map((link) => (
                  <li key={link.name}>
                    <a 
                      href={link.href} 
                      className="text-gray-600 hover:text-black transition-colors"
                    >
                      {link.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
            
            <div>
              <h3 className="font-['Inter'] font-medium text-lg mb-4">Legal</h3>
              <ul className="space-y-3">
                {links.legal.map((link) => (
                  <li key={link.name}>
                    <a 
                      href={link.href} 
                      className="text-gray-600 hover:text-black transition-colors"
                    >
                      {link.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          {/* Bottom Bar */}
          <div className="pt-8 border-t border-gray-200 flex flex-col sm:flex-row justify-between items-center gap-4">
            <div className="text-gray-600 text-sm">
              © 2024 PollBolt. All rights reserved.
            </div>
            <div className="flex gap-6">
              {links.social.map((link) => (
                <a 
                  key={link.name}
                  href={link.href}
                  className="text-gray-600 hover:text-black transition-colors"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {link.name}
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 